import Vue from 'vue';
import VueRouter from 'vue-router';
import RouteNames from '@/router/RouteNames';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: RouteNames.home,
        component: () => import('@/views/Home.vue'),
    },
    {
        path: '/sign-in',
        name: RouteNames.signIn,
        component: () => import('@/views/SignIn.vue'),
    },
    {
        path: '/acl/accounts',
        name: RouteNames.aclAccounts,
        component: () => import('@/views/AclAccounts.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
